import { StoreState } from "../../store";

const selector = (state: StoreState) => state.asset;

export const assetSelectors = {
  showSms: (state: StoreState) => selector(state).showSms,
  maintenanceInfo: (state: StoreState) => selector(state).maintenanceInfo,
};
